// extracted by css-extract-rspack-plugin
export default {"cls1":"TrendAdornment-cls1_mi1","cls2":"TrendAdornment-cls2_Kl_ TrendAdornment-cls1_mi1"};